import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
 
    state: {
      // 存储token
      Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
      userInfo: {},
    },
    mutations: {
      // 修改token，并将token存入localStorage
      changeLogin (state, user) {
        state.Authorization = user.Authorization;
        localStorage.setItem('Authorization', user.Authorization);
      },
      userInfo(state, user) {
        if(user) {
          state.userInfo = user
        } else {
          localStorage.setItem('userInfo', {});
          state.userInfo = {};
        }
      },
      $_setToken(state, value) { // 设置存储token
          state.Authorization = value;
          localStorage.setItem('Authorization', value);
      },
      /*退出清除token*/
      $_removeStorage(state, value){  // 删除token
        localStorage.removeItem('Authorization');
      },
    },
    actions: {
      setUserInfo(context, Object) {
        context.commit('userInfo', Object)
      },
    },
    getters:{
      getStorage(state){// 获取本地存储的登录信息
	      if(!state.Authorization){
        	state.Authorization =JSON.parse(localStorage.getItem(key))
	      }
	      return state.Authorization
	    },
      userInfo(state) {
	      if(!state.userInfo){
        	state.userInfo =JSON.parse(localStorage.getItem(key))
	      }
	      return state.userInfo
      }
    }
  });
   
  export default store;


// WEBPACK FOOTER //
// ./src/store/index.js